import React from 'react';
import PropTypes from 'prop-types';
import { inject } from 'mobx-react';
import {computed} from 'mobx';
import {Link} from 'react-router';

import AppsLinks from '../AppsLinks';

import Logo from './Logo';
import { withI18n } from 'spa/Components/Context';

@inject(({
  store: {
    navigation: {
      header: {
        navigation,
        navigationLogin,
      },
    },
  },
}) => (
  {
    navigation,
    navigationLogin,
  }
))
@withI18n
class PageMenu extends React.Component {
  static propTypes = {
    navigation: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
    navigationLogin: PropTypes.shape({
      title: PropTypes.string,
      url: PropTypes.string,
    }).isRequired,
  };

  @computed get headerLinks() {
    const { navigation, navigationLogin } = this.props;
    const links = [...navigation, ...navigationLogin];
    return links.map(link => (
      <li
        className="page-menu-item"
        key={`page-menu-${link.title.replace(/\s/g, '-').toLowerCase()}-link`}
      >
        <Link
          to={link.url}
          data-testid={`page-menu-${link.title.replace(/\s/g, '-').toLowerCase()}-link`}
        >
          {link.title}
        </Link>
      </li>));
  }

  render() {
    const {i18n} = this.context;

    return (
      <div className="page-menu" data-testid="page-menu-container">
        <div className="v-container">
          <div className="v-content v-content--expand">
            <Link to={`/${i18n.lc}/`} className="page-menu-item page-menu-item--logo" data-testid="page-menu-logo">
              <Logo dark />
            </Link>
            <ul>
              {this.headerLinks}
            </ul>
            <AppsLinks className="page-menu-item page-menu-item--app-links" />
          </div>
        </div>
      </div>
    );
  }
}

export default PageMenu;



// WEBPACK FOOTER //
// ./spa/Components/Header/PageMenu.jsx